import { createAction } from "@reduxjs/toolkit";
import {
  createPostActionTypes,
  getPortionActionTypes,
  getPostsActionTypes,
  updatePostActionType,
  postUploadedActionType,
  deletePostActionTypes,
  likePostActionTypes,
  unlikePostActionTypes,
  showPostByIdActionTypes,
  getFeedPortionActionTypes,
  setPostsActionTypes,
  editPostActionTypes,
  pinPostActionTypes,
  unPinPostActionTypes,
  updatePurchasedPostTypes,
  getFeedPurchasedPostsActionTypes,
  getFeedPurchasedPortionActionTypes,
  toggleShowNewPostsButtonType,
  showNewPostsButtonType,
  toggleNewPostsLoadingType,
  clearPostsType,
} from "./actionTypes";
import { getFeedPostsActionTypes } from "./actionTypes";

export const createPost = createAction(
  createPostActionTypes.request,
  (payload) => ({ payload }),
);

export const createPostSuccess = createAction(
  createPostActionTypes.success,
  (payload) => ({ payload }),
);

export const createPostFailure = createAction(
  createPostActionTypes.failure,
  (error) => ({ payload: error }),
);

export const createPostReset = createAction(
  createPostActionTypes.reset,
  (payload) => ({ payload }),
);

export const getPosts = createAction(
  getPostsActionTypes.request,
  (payload) => ({ payload }),
);

export const getPostsSuccess = createAction(
  getPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const getPostsFailure = createAction(
  getPostsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getPortion = createAction(getPortionActionTypes.request);

export const getPortionSuccess = createAction(
  getPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getPortionFailure = createAction(
  getPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const updatePost = createAction(updatePostActionType, (payload) => ({
  payload,
}));

export const postUploaded = createAction(postUploadedActionType, (payload) => ({
  payload,
}));

export const deletePost = createAction(
  deletePostActionTypes.request,
  (payload) => ({ payload }),
);

export const deletePostSuccess = createAction(
  deletePostActionTypes.success,
  (payload) => ({ payload }),
);

export const deletePostFailure = createAction(
  deletePostActionTypes.failure,
  (payload) => ({ payload }),
);

export const likePost = createAction(
  likePostActionTypes.request,
  (payload) => ({ payload }),
);

export const likePostSuccess = createAction(
  likePostActionTypes.success,
  (payload) => ({ payload }),
);

export const unlikePost = createAction(
  unlikePostActionTypes.request,
  (payload) => ({ payload }),
);

export const unlikePostSuccess = createAction(
  unlikePostActionTypes.success,
  (payload) => ({ payload }),
);

export const showReportedPostById = createAction(
  showPostByIdActionTypes,
  (payload) => ({
    payload,
  }),
);

export const getFeedPosts = createAction(
  getFeedPostsActionTypes.request,
  (payload) => ({ payload }),
);

export const getFeedPostsSuccess = createAction(
  getFeedPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const getFeedPostsFailure = createAction(
  getFeedPostsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getFeedPortion = createAction(getFeedPortionActionTypes.request);

export const getFeedPortionSuccess = createAction(
  getFeedPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getFeedPortionFailure = createAction(
  getFeedPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const setPosts = createAction(
  setPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const editPost = createAction(editPostActionTypes.request);
export const editPostSuccess = createAction(editPostActionTypes.success);
export const editPostFailure = createAction(editPostActionTypes.failure);
export const editPostReset = createAction(editPostActionTypes.reset);

export const pinPost = createAction(pinPostActionTypes.request, (payload) => ({
  payload,
}));

export const pinPostSuccess = createAction(
  pinPostActionTypes.success,
  (payload) => ({ payload }),
);

export const pinPostFailure = createAction(
  pinPostActionTypes.failure,
  (payload) => ({ payload }),
);

export const unpinPost = createAction(
  unPinPostActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const unpinPostSuccess = createAction(
  unPinPostActionTypes.success,
  (payload) => ({ payload }),
);

export const unpinPostFailure = createAction(
  unPinPostActionTypes.failure,
  (payload) => ({ payload }),
);

export const updatePurchasedPost = createAction(
  updatePurchasedPostTypes,
  (payload) => ({ payload }),
);

/* getFeedPurchasedPosts */
export const getFeedPurchasedPosts = createAction(
  getFeedPurchasedPostsActionTypes.request,
  (payload) => ({ payload }),
);

export const getFeedPurchasedPostsSuccess = createAction(
  getFeedPurchasedPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const getFeedPurchasedPostsFailure = createAction(
  getFeedPurchasedPostsActionTypes.failure,
  (payload) => ({ payload }),
);
/* --- */

/* getFeedPurchasedPortion */
export const getFeedPurchasedPortion = createAction(
  getFeedPurchasedPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getFeedPurchasedPortionSuccess = createAction(
  getFeedPurchasedPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getFeedPurchasedPortionFailure = createAction(
  getFeedPurchasedPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const toggleShowNewPostsButton = createAction(
  toggleShowNewPostsButtonType,
  (payload) => ({ payload }),
);

export const showNewPostsButton = createAction(
  showNewPostsButtonType,
  (payload) => ({ payload }),
);

export const toggleNewPostsLoading = createAction(
  toggleNewPostsLoadingType,
  (payload) => ({ payload }),
);

export const clearPosts = createAction(clearPostsType, (payload) => ({
  payload,
}));

/* --- */
